import React from 'react'
import { Box, Button, TextField, Paper, FormControl, InputLabel, Select, MenuItem } from '@mui/material'
import { Grid } from '@mui/material'
import { router, usePage, useForm } from '@inertiajs/react'
import AppShell from '../../../../components/layout/AppShell'
import PageHeader from '../../../../components/ui/PageHeader'

Form.layout = (page) => <AppShell>{page}</AppShell>

export default function Form({ property, payment, bank_accounts = [], contacts = [], action, errors: serverErrors = {} }) {
  const { props } = usePage()
  const tenant = props.tenant || {}
  const isEdit = action === 'edit'
  const basePath = `/m/${tenant.slug}/properties/${property.id}`

  const { data, setData, post, put, processing, errors } = useForm({
    direction: payment.direction || 'inbound',
    amount: payment.amount || '',
    booking_date: payment.booking_date || '',
    reference_text: payment.reference_text || '',
    contact_id: payment.contact_id || '',
    bank_account_id: payment.bank_account_id || '',
  })

  const allErrors = { ...serverErrors, ...errors }

  const handleSubmit = (e) => {
    e.preventDefault()
    if (isEdit) {
      put(`${basePath}/payments/${payment.id}`)
    } else {
      post(`${basePath}/payments`)
    }
  }

  return (
    <Box>
      <PageHeader
        title={isEdit ? 'Zahlung bearbeiten' : 'Neue Zahlung'}
        breadcrumbs={[
          { label: property.name, href: basePath },
          { label: 'Zahlungen', href: `${basePath}/payments` },
          { label: isEdit ? 'Bearbeiten' : 'Neu' },
        ]}
      />

      <Paper elevation={0} sx={{ p: 3, border: '1px solid', borderColor: 'divider', maxWidth: 600 }}>
        <Box component="form" onSubmit={handleSubmit} data-testid="payment-form">
          <Grid container spacing={2}>
            <Grid size={{ xs: 12 }}>
              <FormControl fullWidth size="small" required error={!!allErrors.direction}>
                <InputLabel>Richtung</InputLabel>
                <Select value={data.direction} label="Richtung"
                  onChange={(e) => setData('direction', e.target.value)}
                  data-testid="direction-select"
                >
                  <MenuItem value="inbound">Eingang</MenuItem>
                  <MenuItem value="outbound">Ausgang</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextField label="Betrag" required fullWidth size="small" type="number"
                value={data.amount} onChange={(e) => setData('amount', e.target.value)}
                error={!!allErrors.amount} helperText={allErrors.amount?.[0]}
                slotProps={{ htmlInput: { step: '0.01', min: '0' } }}
                data-testid="amount-input" />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextField label="Buchungsdatum" required fullWidth size="small" type="date"
                value={data.booking_date} onChange={(e) => setData('booking_date', e.target.value)}
                error={!!allErrors.booking_date} helperText={allErrors.booking_date?.[0]}
                slotProps={{ inputLabel: { shrink: true } }}
                data-testid="booking-date-input" />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <FormControl fullWidth size="small" required error={!!allErrors.bank_account_id}>
                <InputLabel>Bankkonto</InputLabel>
                <Select value={data.bank_account_id} label="Bankkonto"
                  onChange={(e) => setData('bank_account_id', e.target.value)}
                  data-testid="bank-account-select"
                >
                  {bank_accounts.map((ba) => (
                    <MenuItem key={ba.id} value={ba.id}>{ba.name} ({ba.iban})</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid size={{ xs: 12 }}>
              <FormControl fullWidth size="small">
                <InputLabel>Kontakt</InputLabel>
                <Select value={data.contact_id || ''} label="Kontakt"
                  onChange={(e) => setData('contact_id', e.target.value)}
                  data-testid="contact-select"
                >
                  <MenuItem value="">— Kein Kontakt —</MenuItem>
                  {contacts.map((c) => (
                    <MenuItem key={c.id} value={c.id}>{c.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextField label="Verwendungszweck" fullWidth size="small" multiline rows={2}
                value={data.reference_text} onChange={(e) => setData('reference_text', e.target.value)}
                error={!!allErrors.reference_text} helperText={allErrors.reference_text?.[0]}
                data-testid="reference-text-input" />
            </Grid>
          </Grid>
          <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
            <Button type="submit" variant="contained" disabled={processing} data-testid="submit-btn">
              {processing ? 'Wird gespeichert...' : 'Speichern'}
            </Button>
            <Button variant="outlined" onClick={() => router.visit(`${basePath}/payments`)}>Abbrechen</Button>
          </Box>
        </Box>
      </Paper>
    </Box>
  )
}
